import { Divider } from '@reveni-io/reveni-ui'

import LocationsSelector from '@/configuration/components/LocationsSelector/LocationsSelector'

import { getLocationPayload, getSelectedLocationId } from '../helpers'
import AddTimeRanges from './AddTimeRanges/AddTimeRanges'
import CarrierService from './CarrierService/CarrierService'

const CustomerPickUpMethod = ({ config, onChange, errors, subscriptionPlan, carriers, onCarrierChange, disabled }) => {
  const handleChangeTimeRange = (id, value, type) => {
    const newTimeRanges = config.time_ranges.map(tr => (tr.id === id ? { ...tr, [type]: value } : tr))

    onChange({ time_ranges: newTimeRanges })
  }

  const onAddTimeRange = () => {
    onChange({
      time_ranges: [...config.time_ranges, { id: Math.random(), start: '09:00', end: '18:00' }],
    })
  }

  const onRemoveTimeRange = id => {
    const newTimeRanges = config.time_ranges.filter(tr => tr.id !== id)

    onChange({ time_ranges: newTimeRanges })
  }

  const onChangeSupportsPickupDate = e => {
    const value = e.target.checked

    if (!value) onChange({ time_ranges: [] })

    onChange({ supports_pickup_dates: value })
  }

  const handleChangeLocation = location => onChange(getLocationPayload(location))

  return (
    <>
      <CarrierService
        carrier={config?.carrier_service}
        carriers={carriers}
        onCarrierChange={onCarrierChange}
        errors={errors}
        subscriptionPlan={subscriptionPlan}
        disabled={disabled}
      />
      <LocationsSelector value={getSelectedLocationId(config)} onChange={handleChangeLocation} errors={errors} />
      {(config?.carrier_service?.supports_time_ranges || !config?.carrier_service?.is_connected) && (
        <>
          <Divider />
          <AddTimeRanges
            timeRanges={config?.time_ranges}
            onAdd={onAddTimeRange}
            onChange={handleChangeTimeRange}
            onRemove={onRemoveTimeRange}
            isCarrierConnected={config?.carrier_service?.is_connected}
            supportsPickupDate={config?.supports_pickup_dates}
            supportsTimeRanges={config?.carrier_service?.supports_time_ranges}
            onChangeSupportsPickupDate={onChangeSupportsPickupDate}
          />
        </>
      )}
    </>
  )
}

export default CustomerPickUpMethod
